<template>
    <AppSidebar :fixed="true">
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="transladedNav" fixed></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
    </AppSidebar>
</template>

<script>
import {
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
} from '@coreui/vue'
import i18n from '@/locales'

import nav from '@/_nav'

export default {
    components: {
        AppSidebar,
        SidebarForm,
        SidebarFooter,
        // SidebarToggler,
        SidebarHeader,
        SidebarNav,
        SidebarMinimizer,
    },

    data() {
        return {
            orgNavItems: nav.items,
        }
    },

    computed: {
        transladedNav() {
            return this.orgNavItems.map(item => {
                if (!item.name) {
                    item.name = i18n.t(item.translatekey)
                }

                return item
            })
            // .map(function(item) {
            //     item.name = i18n.t(item.trans_fullname)
            //     return item
            // })
        },
    },
}
</script>
